<div class="modal-container custom-modal manage-modal-gts" id="wrapper">
  <div class="modal-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center" style="gap: 20px;">
      <h6 class="modal-title">{{ title }}</h6>
      <span *ngIf="!actionFlag" class="cursor add-item" (click)="startAddNew()">New</span>
    </div>
    <div class="actions d-flex align-items-center justify-content-end" style="gap: 10px;overflow-x: clip !important;">
      <span *ngIf="callProFlag" class="companies-list-label ml-1">Insurance:</span>
      <p-dropdown *ngIf="callProFlag" #dropdown1 [options]="companiesList" [(ngModel)]="selectedCompanyValue" 
        [ngClass]="{'active': selectedCompanyValue}" placeholder="Select Company" [showClear]="false" appendTo="body"
        [virtualScroll]="false" [itemSize]="5" [filter]="true" filterBy="name" resetFilterOnHide="true"
        (onChange)="filterCompany($event)" class="custom-select-jobs-pupup-dropdown" panelStyleClass="custom-select-jobs-pupup-dropdown">
        <ng-template pTemplate="selectedItem">
          <div class="country-item country-item-value" *ngIf="selectedCompanyValue">
            <div style="color: #fff !important;">
              <img class="company-pic display" [src]="selectedCompanyValue?.logo || 'assets/images/repair-order/Insurance-Company-Logo.svg'" 
                alt="" srcset="" />
              {{selectedCompanyValue?.name}}
            </div>
          </div>
        </ng-template>
        <ng-template let-compList pTemplate="item" let-i="index">
          <!-- <div class="shop-item" (click)="newCompany();$event.stopPropagation();dropdown1.hide();" *ngIf="compList?.id == 0">
            <span class="d-flex align-items-center" style="color: #469073;">
              <img class="mr-1" width="12px" src="assets/images/service-provider/add-plus.png">
              Add New
            </span>
          </div> -->
          <div (mouseenter)="compListhoveredIndex = compList?.id" (mouseleave)="compListhoveredIndex = null" 
            class="option-item d-flex align-items-center justify-content-between" *ngIf="compList?.id != 0">
            <div class="d-flex align-items-center">
              <img class="company-pic" [src]="compList?.logo || 'assets/images/repair-order/Insurance-Company-Logo.svg'" 
                alt="" srcset="">
              <span>{{compList.name}}</span>
            </div>
            <!-- <img *ngIf="compListhoveredIndex === compList?.id && compList?.name != 'General'" 
              class="cursor-pointer" (click)="editCompany(compList);$event.stopPropagation();dropdown1.hide();" 
              src="assets/images/repair-order/edit_-icon-green.svg" /> -->
          </div>
        </ng-template>
      </p-dropdown>
      <form class="search-form position-static" [formGroup]="searchForm" 
        style="width: 30% !important; height: 32px !important;display: flex !important;align-items: center !important; border-radius: 20px !important;padding: 4px 6px !important;">
        <a *ngIf="!searchTick && !searchClose" class="search-icon" style="top: -6px;">
          <img alt="Search" src="assets/images/search-icon.png">
        </a>
        <input type="text" autocomplete="off" class="form-control search-control"
          formControlName="searchKey" maxlength="30" placeholder="Search" (input)="onSearchChange($event.target.value)"
          [ngClass]="{ 'is-invalid': submitted && f.searchKey.errors }" (keyup.enter)="applySearch()"
          style="border: none !important;outline: none !important;width: 84% !important;min-width: 84% !important;color: #fff !important;">
          <span class="d-flex align-items-center" style="gap: 7px;position: relative;z-index: 10;">
            <span *ngIf="searchClose" class="cursor-pointer" (click)="clearSearch()">
              <i class="pi pi-times" style="font-size: 1rem; color: #b6bac3;"></i>
            </span>
            <span *ngIf="searchClose" class="cursor-pointer" (click)="applySearch()">
              <i class="pi pi-search" style="font-size: 1rem; color: #b6bac3;"></i>
            </span>
          </span>
      </form>
      <span class="cursor save-item" (click)="applySelection()"
        [ngClass]="{ 'save-btn-disabled': !selectedList.length}">
        <span>Save</span>
        <i class="pi pi-check" style="font-size: 1rem"></i>
      </span>
      <span class="cursor close ml-0" style="top: 0px !important;" (click)="close()">
        <img src="assets/images/list-close.png" alt="Close" />
      </span>
    </div>
  </div>

  <div class="modal-body">
    <div *ngIf="!empty" id="manageTable" class="container scrollbar scrollbar-primary thin" 
      [style.height.px]="height" style="max-width: 100% !important;width: 100% !important;">
      <div *ngIf="success" class="parent-succ-div">
        <div class="success-msg"><span>{{ successMsg }}</span></div>
      </div>
      <table class="manage-table manage-table-jobs">
        <thead class="manage-header">
          <tr class="header-row">
            <th style="width: 5%;"></th>
            <th style="width: 10%;">Job Code</th>
            <th style="width: 20%;">Job Title</th>
            <th style="width: 35%;">Job Description</th>
            <th style="width: 10%;">Price</th>
            <th style="width: 10%;">Discount</th>
            <th style="width: 10%;">WD</th>
            <!-- <th colspan="3">
              <div class="title">
                <span class="cursor checkbox" [ngClass]="checkboxColor" (click)="toggleAll()"></span>
                {{ title }} List
              </div>
              <div class="actions">
                <div *ngIf="selectedList.length" class="action-col cursor clear" (click)="clearSelection()"
                  [ngClass]="{ 'show': selectedList.length, 'hide': !selectedList.length }">
                  Clear All
                </div>
                <div class="action-col apply" (click)="applySelection()"
                  [ngClass]="{ 'cursor active': selectedList.length, 'inactive': !selectedList.length }">
                  Save
                </div>
              </div>
            </th> -->
          </tr>
        </thead>
        <tbody *ngIf="loading" class="manage-items">
          <tr>
            <td colspan="7">
              <div class="loader"><img src="assets/images/loading.svg" alt="Loader" /></div>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading" class="manage-items">
          <tr *ngFor="let item of listItems; let i = index"
            [ngClass]="{ 'item-list cursor': true, 'deactive': item.editAccess === 0 }"
            [style.display]="item.displayFlag ? '' : 'none'"
            [style.background]="item?.isAvailable == 1 ? '#fff !important' : '#f6f6f7 !important'">
            <td style="width: 5%; text-align: start !important; color: #000;">
              <div class="d-flex align-items-center">
                <span *ngIf="item.action == ''" class="checkbox" style="position: relative !important;top: 0 !important;"
                  [ngClass]="{'inactive': !item.checkFlag, 'active': item.checkFlag}"
                  (click)="toggleItemSelection(item)">
                </span>
              </div>
            </td>
            <td style="width: 10%; text-align: start !important; color: #000;">
              <div class="d-flex align-items-center">
                <span *ngIf="item.action == ''" class="d-block w-100" 
                  style="top: 0px !important;position: relative !important;"
                  (click)="toggleItemSelection(item)">
                  {{ item?.jobCode || "-" }}
                </span>
                <span *ngIf="item.action === 'new'" class="w-100 model-input position-static">
                  <input type="text" class="form-control model-control" [(ngModel)]="jobCode" maxlength="50"
                      placeholder="Job Code" style="color: #000 !important;width: 90px !important;min-width: 90px !important;" />
                </span>
              </div>
            </td>
            <td style="width: 20%;text-align: start !important; color: #000;">
              <div class=" d-flex align-items-center">
                <span *ngIf="item.action == ''" class="d-block w-100" style="flex: 1;" 
                  (click)="toggleItemSelection(item)">
                  <div>{{ item?.jobtitle || "-" }}</div>
                  <div *ngIf="item?.optionValue" style="color: #777777;font-style: italic;">
                    {{ item?.optionTypeName }}: {{ item?.optionValue }}
                  </div>
                  
                </span>
                <span *ngIf="item.action === 'new'" class="model-input position-relative" style="top: 0px !important;">
                  <input type="text" class="form-control model-control" [(ngModel)]="jobTitle" maxlength="50"
                      placeholder="Enter Job Title" style="color: #000 !important;" />
                </span>
              </div>
            </td>
            <td style="width:35%;text-align: start !important; color: #000;">
              <div class="d-flex align-items-center">
                <span *ngIf="item.action == ''" class="d-block w-100 px-2" style="flex: 1;" 
                  (click)="toggleItemSelection(item)">
                  {{ item?.jobdesc || "-" }}
                </span>
                <span *ngIf="item.action === 'new'" class="model-input position-relative" style="top: 0px !important;">
                  <input type="text" class="form-control model-control" [(ngModel)]="jobDesc" maxlength="50"
                      placeholder="Enter Description" style="color: #000 !important;" />
                </span>
              </div>
            </td>
            <td style="width: 10%;text-align: start !important; color: #000;">
              <div class="d-flex align-items-center">
                <span *ngIf="item.action == ''" class="d-block w-100" style="flex: 1;" 
                  (click)="toggleItemSelection(item)">
                  ${{ item?.unitPrice || "0" }}
                </span>
                <span *ngIf="item.action === 'new'" class="model-input position-relative" style="top: 0px !important;">
                  <input type="text" class="form-control model-control" [(ngModel)]="jobPrice" maxlength="50"
                      placeholder="Enter Price" style="color: #000 !important;" />
                </span>
              </div>
            </td>
            <td style="width: 10%;text-align: start !important; color: #000;">
              <div class=" d-flex align-items-center">
                <span *ngIf="item.action == ''" class="d-block w-100" style="flex: 1;" 
                  (click)="toggleItemSelection(item)">
                  {{ item?.discount || "0" }}%
                </span>
                <span *ngIf="item.action === 'new'" class="model-input position-relative" style="top: 0px !important;">
                  <input type="text" class="form-control model-control" [(ngModel)]="jobDiscount" maxlength="50"
                      placeholder="Enter Discount" style="color: #000 !important;" />
                </span>
              </div>
            </td>
            <td style="width: 10%;text-align: start !important; color: #000;">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span *ngIf="item.action == ''" class="d-block w-100" style="flex: 1;" 
                    (click)="toggleItemSelection(item)">
                    ${{ item?.wdPrice || "0" }}
                  </span>
                  <span *ngIf="item.action === 'new'" class="model-input position-relative" style="top: 0px !important;">
                    <input type="text" class="form-control model-control" [(ngModel)]="jobWd" maxlength="50"
                        placeholder="Enter" style="color: #000 !important;" />
                  </span>
                </div>
                <div *ngIf="item.action == ''" style="position: relative;">
                  <span id="more" class="more-icon" [matMenuTriggerFor]="more" (click)="$event.stopPropagation();"
                    style="    position: absolute;top: 34%;">
                    <img src="assets/images/more-icon.svg" alt="Action" onload="SVGInject(this)" />
                  </span>
                  <mat-toolbar color="primary">
                    <mat-menu #more="matMenu" backdropClass="ptabletmenu">
                      <div class="part-menu">
                          <ul class="more-actions">
                            <li class="cursor active" (click)="editJob(item)">
                              <img src="assets/images/edit.png" alt="Edit">&nbsp;&nbsp;Edit
                            </li>
                            <li *ngIf="item?.isAvailable == 1" class="cursor active" (click)="deleteJob(item)">
                              <img src="assets/images/delete.png" alt="Delete">&nbsp;&nbsp;Delete
                            </li>                                    
                          </ul>
                      </div>
                    </mat-menu>
                  </mat-toolbar>
                </div>
                <div *ngIf="item.action === 'new'" class="manage-actions">
                    <ul class="add-action-ul mb-0 pl-1">
                      <li class="submit-icon-new active">
                        <img class="cursor" src="assets/images/checkbox-active.png" (click)="confirmAddNew()" />
                      </li>
                      <li class="close-icon-new">
                        <img class="cursor" src="assets/images/close.png" (click)="cancelAddNew()" />
                      </li> 
                    </ul>
                </div>
              </div>
            </td>
            <!-- <td class="action-cont">
              <div class="manage-actions">
                <ng-container *ngIf="item.action === 'new'">
                  <ul class="add-action-ul mb-0">
                    <li class="submit-icon active">
                      <img class="cursor" src="assets/images/checkbox-active.png" (click)="confirmAddNew()" />
                    </li>
                    <li class="close-icon">
                      <img class="cursor" src="assets/images/close.png" (click)="cancelAddNew()" />
                    </li> 
                  </ul>
                </ng-container>
                <span *ngIf="item.action !== 'new'" class="d-flex align-items-center justify-content-end" style="gap: 4px;" 
                  (click)="startAddNew(item)">
                  <span class="pi pi-pencil" style="font-size: 1rem"></span>
                  <span>Edit</span>
                </span> 
              </div>
            </td> -->
          </tr>
          <tr *ngIf="!loading && isLoadingMore">
            <td colspan="7">
              <div class="loader"><img src="assets/images/loading.svg" alt="Loader" /></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="empty" class="no-item-list" [style.height.px]="height">
      <div class="item-empty-container">
        <div class="empty-cont">
          <div class="text-center empty-res">
            <div class="empty-bg"></div>
            <!-- <div>{{ successMsg }}</div> -->
            <div>No result found</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>